import {toast} from 'react-toastify';
export function showSucces(msg) {
   toast.success(msg, {theme: 'colored'});
}
export function showError(msg) {
   toast.error(msg, {theme: 'colored'});
}
export function showWarning(msg) {
   toast.warn(msg, {theme: 'colored'});
}
export function showInfo(msg) {
   toast.info(msg, {theme: 'colored'});
}
